
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_Tabs";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_Tabs__root","text-medium-normal":"wds_1_76_1_StylableTypography__text-medium-normal","text-small-normal":"wds_1_76_1_StylableTypography__text-small-normal","container":"wds_1_76_1_Tabs__container","itemsContainer":"wds_1_76_1_Tabs__itemsContainer","tab":"wds_1_76_1_Tabs__tab","compact":"wds_1_76_1_Tabs__compact","uniformFull":"wds_1_76_1_Tabs__uniformFull","compactSide":"wds_1_76_1_Tabs__compactSide","tabText":"wds_1_76_1_Tabs__tabText","sideContent":"wds_1_76_1_Tabs__sideContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"sidePadding":"0","sideMargin":"30px","compactSideMargin":"18px"}; 
export var vars = {}; 




